import {fightService} from '@/services/PlayerFight';
import {clearActingCharacter, setActingCharacter} from '@/api/actingCharacter';

/*
 * The training route's session, and the binding that makes every request it
 * issues act as the clone. Nothing else in the app may hold this: `/game` must
 * stay unaware that a training exists at all.
 */
let boundSession = null;

export function activeTrainingSession() {
    return boundSession;
}

/**
 * Resolve the open training of `characterId` (the real character) and act as
 * its clone from here on. Returns null when there is nothing to resume, and
 * leaves nothing bound in that case.
 *
 * The lookup itself must not carry a stale binding, or the server would resolve
 * the previous clone rather than the character asked about.
 */
export async function bindTrainingSession(characterId) {
    release();
    let session = null;
    try {
        session = await fightService.getCurrentTraining(characterId);
    } catch {
        session = null;
    }
    if (!session) {
        return null;
    }
    boundSession = session;
    setActingCharacter(session.clone?.id);
    return session;
}

export function releaseTrainingSession() {
    release();
}

export async function startTraining(characterId) {
    return fightService.startOrResumeTraining(characterId);
}

/**
 * `characterId` is the real character; omitting it ends the bound session.
 */
export async function endTraining(characterId) {
    const target = characterId || boundSession?.source_character?.id;
    /* Ending is authorised by ownership of the session, not by acting as the
       clone — and the clone is deleted by the call itself. */
    release();
    await fightService.endTraining(target);
}

export async function trainingSessionFor(characterId) {
    return fightService.getCurrentTraining(characterId);
}

function release() {
    boundSession = null;
    clearActingCharacter();
}
